import { render, staticRenderFns } from "./general-dialog.vue?vue&type=template&id=235fa77e&scoped=true"
import script from "./general-dialog.vue?vue&type=script&lang=js"
export * from "./general-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235fa77e",
  null
  
)

export default component.exports